import { Box } from "@mui/material";

interface RoundTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function RoundTabPanel({ children, value, index, ...other }: RoundTabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`round-tabpanel-${index}`}
      aria-labelledby={`round-tab-${index}`}
      {...other}
    >
      {value === index ? <Box>{children}</Box> : null}
    </div>
  );
}
